module.exports = __webpack_public_path__ + "icon-alertminer-upgrade.b0ef37edef1f80dd7947.png";